<form
  *ngIf="filtersForm"
  class="filters-form tw-flex tw-flex-wrap tw-items-end tw-gap-x-8 md:tw-gap-x-4"
  [formGroup]="filtersForm"
>
  <ng-container *ngFor="let filter of settings.items">
    <ng-container [ngSwitch]="filter.type">
      <mat-form-field *ngSwitchCase="filterType.Search" class="{{ filter.name }} tw-flex">
        <mat-label>{{ filter.label | translate }}</mat-label>
        <input
          matInput
          formControlName="{{ filter.name }}"
          placeholder="{{ filter.placeholder | translate }}"
          [searchSlash]="filtersForm.get(filter.name).value"
        />
        <ui-svg-icon [name]="iconNames.Search" matSuffix></ui-svg-icon>
      </mat-form-field>

      <mat-form-field *ngSwitchCase="filterType.CustomSearch" class="{{ filter.name }} tw-flex">
        <mat-label>{{ filter.label | translate }}</mat-label>
        <input
          matInput
          formControlName="{{ filter.name }}"
          placeholder="{{ filter.placeholder | translate }}"
          [searchSlash]="filtersForm.get(filter.name).value"
        />
        <ui-svg-icon [name]="filter.icon" matSuffix></ui-svg-icon>
      </mat-form-field>

      <mat-form-field *ngSwitchCase="filterType.Select" class="{{ filter.name }} filter-select tw-flex">
        <mat-label>{{ filter.label | translate }}</mat-label>
        <mat-select formControlName="{{ filter.name }}" multiple="{{ filter.isMultiple }}">
          <mat-option *ngFor="let option of filter.options" [value]="option.value">
            {{ option.name | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngSwitchCase="filterType.ToggleGroup" class="toggle-group tw-flex tw-flex-col">
        <mat-label class="{{ filter.name }} fixed-filter-label">{{ filter.label | translate }}</mat-label>
        <mat-button-toggle-group
          [value]="filtersForm.get(filter.name).value"
          (change)="filtersForm.get(filter.name).setValue($event.value)"
        >
          <mat-button-toggle *ngFor="let option of filter.options" [value]="option.value">
            {{ option.name | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <mat-form-field *ngSwitchCase="filterType.SearchChips" class="{{ filter.name }} filter-chips tw-flex">
        <mat-label>{{ filter.label | translate }}</mat-label>
        <mat-chip-grid #inputChipList>
          <mat-chip-row
            *ngFor="let item of filtersForm.get(filter.name).value"
            [removable]="true"
            (removed)="removeElement(filtersForm.get(filter.name), item)"
          >
            {{ item }}
            <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
          </mat-chip-row>
          <div class="tw-flex tw-grow tw-shrink-0 tw-basis-[100px] tw-items-center">
            <input
              #input
              [formControl]="chipsInputControl"
              [placeholder]="filter.placeholder | translate"
              [matChipInputFor]="inputChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              [readonly]="false"
              (matChipInputTokenEnd)="addElement(filtersForm.get(filter.name), input, chipsInputControl)"
            />
            <ui-svg-icon [name]="filter.icon" matIconSuffix></ui-svg-icon>
          </div>
        </mat-chip-grid>
      </mat-form-field>

      <ui-date-time-range
        *ngSwitchCase="filterType.DateTimeRange"
        class="filter-range"
        formControlName="{{ filter.name }}"
        [label]="filter.label | translate"
        [pickerType]="filter.pickerType"
        [initialValue]="filter.initialValue"
        #dateTimeRangeComponent
      >
        <ng-template *ngIf="isTimeRangeResetAvailable" #suffix>
          <div class="suffix">
            <ui-svg-icon
              [name]="iconNames.CalendarClock"
              (click)="dateTimeRangeComponent.datetimePicker.open()"
              class="pointer"
            ></ui-svg-icon>
            <ui-svg-icon
              [name]="iconNames.Close"
              (click)="dateTimeRangeComponent.resetDatepicker()"
              class="pointer tw-ml-2"
            ></ui-svg-icon>
          </div>
        </ng-template>
      </ui-date-time-range>
    </ng-container>
  </ng-container>
  <ng-content></ng-content>
</form>
